export enum DATA_QA {
  ROOT = 'csv-upload',
  CONTAINER = 'csv-upload__container',
  FILE_INPUT = 'csv-upload__file-input',
  FILE_NAME = 'csv-upload__file-name',
  UPLOAD_LINK = 'csv-upload__upload-link',
  HEADERS = 'csv-upload__headers',
  UPLOAD_ANOTHER = 'csv-upload__upload-another',
  CLEAR = 'csv-upload__clear',
  ERROR_MESSAGE = 'csv-upload__error-message',
  DOWNLOAD_TEMPLATE = 'csv-upload__download-template',
}

export const TEMPLATE_DATA = [
  [
    'CANDIDATEID',
    'NAME',
    'SURNAME1',
    'SURNAME2',
    'MOBILE',
    'TELEPHONE',
    'EMAIL',
    'ZIP',
    'STATE',
    'CITY',
    'SOURCE',
    'STATUS',
    'PREFEREDLANGUAGE',
    'OVK/PLAN/VAC',
    'LASTCONTRACTFROM',
    'LASTCONTRACTTO',
  ],
  [
    'A1234567',
    'Firstname',
    'Surname',
    'Surname2',
    '+3284522372',
    '',
    'emailuser@domain.com',
    '0',
    '',
    'BRUSSELS',
    'duo',
    'actief',
    'Nederlands',
    'Nee',
    '03/12/2024',
    '04/12/2024',
  ],
];
